import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm} from 'utils/common';

class InitializeAccountProfileForm extends React.Component {
  render() {
    const params = new URLSearchParams(location.search);
    const {handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <p className="flex-row-center">
          <img alt="Kluwell" src="/images/kluwell-banner.jpg" />
        </p>
        <h4 className="flex-row-center">
          {params.get('role') === 'parent'
            ? 'Thanks for joining Kluwell My Home Reading App. Enter Parent/ Carer’s details to proceed'
            : 'Thanks for joining Kluwell My Home Reading App. Please enter your details to proceed'}
        </h4>
        <Row>
          <Col md={12}>
            <Field
              name="username"
              label="Username"
              component={fields.Input}
              required
              validate={[validators.isRequired, validators.isUsername]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="firstName"
              label="First Name"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="lastName"
              label="Last Name"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              name="password"
              label="Password"
              component={fields.Input}
              required
              type="password"
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="confirmPassword"
              label="Confirm Password"
              component={fields.Input}
              required
              type="password"
              validate={[validators.isRequired, validators.isConfirmPasswordMatch]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default makeForm(InitializeAccountProfileForm, 'InitializeAccountProfileForm', null, null);
